import React, {FC, ReactNode} from 'react';
import {TextDisplay, TextDisplayProps} from "./TextDisplay";
import {Dateable} from "../../../models/common/TimePeriodable";
import {Nullable} from "../../../models/common/Nullable";
import {formatDate, formatDateTime, formatTime} from "../../../helpers/DateTimeHelpers";
import {LanguageProp} from "../../../config/LanguageConfig";
import {LanguageContext} from "../../../config/ContextConfig";
import { useContext } from 'react';

export interface DateTimeDisplayProps extends TextDisplayProps, Partial<LanguageProp> {
    dateTime: Nullable< Dateable >
    /** if true, only the date part will be displayed */
    dateOnly?: boolean
    timeOnly?: boolean
    /** when date null, will be displayed instead of nothing */
    ifNullComponent?: React.ReactNode
}

/**
 * Wrapper component around TextDisplay, which automatically formats the given time
 *
 * date formatting rules:
 * default: complete date time is displayed
 * dateOnly: only date is shown
 * timeOnly: only time is shown, override dateOnly if both are set
 * TODO("dateOnly and timeOnly should be refactored to one property. something like: format: dateOnly | timeOnly | datetime")
 */
export function DateTimeDisplay({
        align,
        variant,
        textColor,
        onClick,
        className,
        language,
        dateTime,
        dateOnly,
        timeOnly,
        style,
        ifNullComponent,
     }: DateTimeDisplayProps
) {
    const lang = useContext( LanguageContext );

    if( typeof ifNullComponent !== "undefined" && dateTime === null ) {
        return (
            <>
                {ifNullComponent}
            </>
        )

    }

    let formattedDate = formatDateTime( dateTime, language || lang );

    if( dateOnly ) {
        formattedDate = formatDate( dateTime, language || lang );
    }

    if( timeOnly && dateTime !== null ) {
        formattedDate = formatTime( dateTime, language || lang );
    }


    return (
        <TextDisplay
            variant={ variant }
            onClick={ onClick }
            textColor={ textColor }
            className={ className}
            align={ align }
            style={ style }
        >
            { formattedDate }
        </TextDisplay>
    );
}